import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AddCustomerApi, GetAllTerms } from "../../api";
import { Header, Button } from "../../components";
import { useStateContext } from "../../contexts/ContextProvider";
import TimeoutUtility from "../../contexts/TimeoutUtility";
import "../../styles/AddPart.css";
import { Container, Col, Row } from "react-bootstrap";
import { validateField } from "../../contexts/Utils";
import { Geocoder } from "@mapbox/search-js-react";
import TextAreaField from "../../components/TextAreaField";
import TextInputField from "../../components/TextInputField";
import DoubleField from "../../components/DoubleField";
import SelectField from "../../components/SelectField";
import { showSuccessToast, showErrorToast } from "../../components/ToastMesg";
import CountrySelector from "../../components/CountrySelect";

const AddCustomer = () => {
  const navigate = useNavigate();
  const { currentColor, storeG } = useStateContext();
  const [getcType, setGetcType] = useState([]);
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    website: "",
    contact_name: "",
    contact_phone: "",
    contact_email: "",
    term: "Select Term",
    balance: "0",
    notes: "",
    b_street: "",
    b_city: "",
    b_state: "",
    b_zip: "",
    b_country: { value: "US", label: "United States" },
    b_phone1: "",
    b_phone2: "",
    s_street: "",
    s_city: "",
    s_state: "",
    s_zip: "",
    s_country: { value: "US", label: "United States" },
    s_name: "",
    s_phone: "",
  });
  const [errors, setErrors] = useState({});
  const [loadBtn, setLoadBtn] = useState(false);
  const mapboxToken = process.env.REACT_APP_MAPBOX_TOKEN;

  const handleBackClick = () => {
    TimeoutUtility.resetTimeout();
    navigate("/Customer");
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    const error = validateField(name, value, name);
    setErrors((prev) => ({ ...prev, [name]: error }));
  };

  const handleSelectChange = (option, e) => {
    if (option && option.value) {
      setFormData((prev) => ({ ...prev, [e.name]: option }));
      const error = validateField(e.name, option, e.name);
      setErrors((prev) => ({ ...prev, [e.name]: error }));
    } else setFormData((prev) => ({ ...prev, [e.name]: "select" }));
  };

  const handleGeocoderRetrieveBill = (res) => {
    if (res?.properties?.context)
      setFormData((prev) => ({
        ...prev,
        b_street: res.properties.name,
        b_city: res.properties.context.place.name || "",
        b_state: res.properties.context.region.name || "",
        b_country: {
          value: res.properties.context.country.country_code || "US",
          label: res.properties.context.country.name || "United States",
        },
        b_zip: res.properties.context.postcode.name || "",
      }));
  };

  const handleGeocoderRetrieveShip = (res) => {
    if (res?.properties?.context)
      setFormData((prev) => ({
        ...prev,
        s_street: res.properties.name,
        s_city: res.properties.context.place.name || "",
        s_state: res.properties.context.region.name || "",
        s_country: {
          value: res.properties.context.country.country_code || "US",
          label: res.properties.context.country.name || "United States",
        },
        s_zip: res.properties.context.postcode.name || "",
      }));
  };

  const handleCopyClick = (e) => {
    e.preventDefault();
    TimeoutUtility.resetTimeout();
    setFormData((prev) => ({
      ...prev,
      s_street: formData.b_street,
      s_city: formData.b_city,
      s_state: formData.b_state,
      s_zip: formData.b_zip,
      s_phone: formData.b_phone1,
      s_country: formData.b_country,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    TimeoutUtility.resetTimeout();
    setLoadBtn(true);

    const newErrors = {};
    Object.keys(formData).forEach((key) => {
      const error = validateField(key, formData[key], key);
      if (error) newErrors[key] = error;
    });
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      setLoadBtn(false);
      return;
    }

    let term_id = null;
    if (formData.term !== "select" && formData.term !== "Select Term") {
      term_id = formData.term.value;
    }
    try {
      const response = await AddCustomerApi(
        storeG.store_id,
        formData.name,
        formData.phone,
        formData.email,
        formData.website,
        formData.contact_name,
        formData.contact_phone,
        formData.contact_email,
        term_id,
        formData.balance,
        formData.b_street,
        formData.b_city,
        formData.b_state,
        formData.b_zip,
        formData.b_country?.label || "",
        formData.b_phone1,
        formData.b_phone2,
        formData.s_street,
        formData.s_city,
        formData.s_state,
        formData.s_zip,
        formData.s_country?.label || "",
        formData.s_name,
        formData.s_phone,
        formData.notes,
      );
      if (response.success) {
        showSuccessToast("Success!", "Customer added successfully.");
        navigate("/Customer");
      } else
        showErrorToast(
          "Error!",
          "Customer failed to add!\n\n" + response.message,
        );
    } catch (err) {
      showErrorToast("Error!", "Customer failed to add!");
    } finally {
      setLoadBtn(false);
    }
  };

  useEffect(() => {
    TimeoutUtility.resetTimeout();
    async function fetchData() {
      await GetAllTerms()
        .then((resp) => {
          const typeOptions = resp.data.map((item) => ({
            label: item.name,
            value: item.term_id,
          }));
          setGetcType(typeOptions || []);
        })
        .catch((err) => console.log(err.message));
    }
    fetchData();
  }, []);

  return (
    <div className="m-0 md:m-4 p-4 md:p-8 main-div-bg">
      <Header title="ADD CUSTOMER" />
      <form>
        <Container className="g-0 form-container" fluid="true">
          <Row xs={1} sm={1} className="p-0 justify-content-center">
            <Col md={3} className="container-col">
              <div className="col-lg-12">
                <div className="form-group text-xl">
                  <b style={{ color: currentColor }}>GENERAL INFORMATION</b>
                </div>
                <TextInputField
                  label="Name:"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Name"
                  compulsory={true}
                  error={errors.name}
                />
                <TextInputField
                  label="Phone:"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="Phone"
                  compulsory={true}
                  error={errors.phone}
                />
                <TextInputField
                  label="Email:"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Email"
                  compulsory={true}
                  error={errors.email}
                />
                <TextInputField
                  label="Website:"
                  name="website"
                  value={formData.website}
                  onChange={handleChange}
                  placeholder="Website"
                  error={errors.website}
                />
                <DoubleField
                  label="Opening Balance:"
                  name="balance"
                  value={formData.balance}
                  onChange={handleChange}
                  placeholder="Opening Balance"
                  min="0"
                  step="1.00"
                  compulsory={true}
                  error={errors.balance}
                />
              </div>
            </Col>
            <Col md={3} className="container-col">
              <div className="col-lg-12">
                <div className="form-group text-xl">
                  <b style={{ color: currentColor }}>CONTACT INFORMATION</b>
                </div>
                <TextInputField
                  label="Contact Name:"
                  name="contact_name"
                  value={formData.contact_name}
                  onChange={handleChange}
                  placeholder="Contact Name"
                  compulsory={true}
                  error={errors.contact_name}
                />
                <TextInputField
                  label="Contact Phone:"
                  name="contact_phone"
                  value={formData.contact_phone}
                  onChange={handleChange}
                  placeholder="Contact Phone"
                  compulsory={true}
                  error={errors.contact_phone}
                />
                <TextInputField
                  label="Contact Email:"
                  name="contact_email"
                  value={formData.contact_email}
                  onChange={handleChange}
                  placeholder="Contact Email"
                  compulsory={true}
                  error={errors.contact_email}
                />
                <SelectField
                  label="Terms:"
                  name="term"
                  value={formData.term}
                  options={getcType}
                  onChange={handleSelectChange}
                  placeholder="Terms"
                  error={errors.term}
                />
                <TextAreaField
                  label="Note:"
                  name="notes"
                  value={formData.notes}
                  onChange={handleChange}
                  placeholder="Notes"
                  error={errors.notes}
                />
              </div>
            </Col>
            <Col md={3} className="container-col">
              <div className="article-container-cus1">
                <div className="article-cu3">
                  <div className="col-lg-12">
                    <div className="form-group text-xl">
                      <b style={{ color: currentColor }}>BILLING ADDRESS</b>
                    </div>
                  </div>
                </div>
                <div className="article-cu2">
                  <button
                    style={{
                      padding: "4px",
                      backgroundColor: currentColor,
                      color: "#fff",
                      border: "none",
                      fontWeight: "bold",
                      width: "30px",
                    }}
                    onClick={handleCopyClick}
                  >
                    C
                  </button>
                </div>
              </div>
              <div className="col-lg-12">
                <div className={`form-group mt-3`}>
                  <label className="label">Street Address:</label>
                  <br />
                  <div className="geocoder-wrapper">
                    <Geocoder
                      accessToken={mapboxToken}
                      onRetrieve={handleGeocoderRetrieveBill}
                      options={{
                        language: "en",
                        // country: "US", // Restrict to US
                        types: "address,street", // Focus on addresses
                        limit: 8, // Up to 8 suggestions
                      }}
                      placeholder="Enter street address..."
                    />
                  </div>
                </div>
                <TextAreaField
                  label="Street:"
                  name="b_street"
                  value={formData.b_street}
                  onChange={handleChange}
                  placeholder="Street"
                  error={errors.b_street}
                />
                <TextInputField
                  label="City:"
                  name="b_city"
                  value={formData.b_city}
                  onChange={handleChange}
                  placeholder="City"
                  error={errors.b_city}
                />
                <TextInputField
                  label="Zip:"
                  name="b_zip"
                  value={formData.b_zip}
                  onChange={handleChange}
                  placeholder="Zip"
                  error={errors.b_zip}
                />
                <TextInputField
                  label="State:"
                  name="b_state"
                  value={formData.b_state}
                  onChange={handleChange}
                  placeholder="State"
                  error={errors.b_state}
                />
                <CountrySelector
                  label="Country:"
                  name="b_country"
                  value={formData.b_country}
                  onChange={handleSelectChange}
                  placeholder="Country"
                  error={errors.b_country}
                />
                <TextInputField
                  label="Phone 1:"
                  name="b_phone1"
                  value={formData.b_phone1}
                  onChange={handleChange}
                  placeholder="Phone 1"
                  error={errors.b_phone1}
                />
                <TextInputField
                  label="Phone 2:"
                  name="b_phone2"
                  value={formData.b_phone2}
                  onChange={handleChange}
                  placeholder="Phone 2"
                  error={errors.b_phone2}
                />
              </div>
            </Col>
            <Col md={3} className="container-col">
              <div className="col-lg-12">
                <div className="form-group text-xl">
                  <b style={{ color: currentColor }}>SHIPPING ADDRESS</b>
                </div>
                <div className={`form-group mt-3`}>
                  <label className="label">Street Address:</label>
                  <br />
                  <div className="geocoder-wrapper">
                    <Geocoder
                      accessToken={mapboxToken}
                      onRetrieve={handleGeocoderRetrieveShip}
                      options={{
                        language: "en",
                        // country: "US", // Restrict to US
                        types: "address,street", // Focus on addresses
                        limit: 8, // Up to 8 suggestions
                      }}
                      placeholder="Enter street address..."
                    />
                  </div>
                </div>
                <TextAreaField
                  label="Street:"
                  name="s_street"
                  value={formData.s_street}
                  onChange={handleChange}
                  placeholder="Street"
                  error={errors.s_street}
                />
                <TextInputField
                  label="City:"
                  name="s_city"
                  value={formData.s_city}
                  onChange={handleChange}
                  placeholder="City"
                  error={errors.s_city}
                />
                <TextInputField
                  label="Zip:"
                  name="s_zip"
                  value={formData.s_zip}
                  onChange={handleChange}
                  placeholder="Zip"
                  error={errors.s_zip}
                />
                <TextInputField
                  label="State:"
                  name="s_state"
                  value={formData.s_state}
                  onChange={handleChange}
                  placeholder="State"
                  error={errors.s_state}
                />
                <CountrySelector
                  label="Country:"
                  name="s_country"
                  value={formData.s_country}
                  onChange={handleSelectChange}
                  placeholder="Country"
                  error={errors.s_country}
                />
                <TextInputField
                  label="Attention Name:"
                  name="s_name"
                  value={formData.s_name}
                  onChange={handleChange}
                  placeholder="Attention Name"
                  error={errors.s_name}
                />
                <TextInputField
                  label="Phone:"
                  name="s_phone"
                  value={formData.s_phone}
                  onChange={handleChange}
                  placeholder="Phone"
                  error={errors.s_phone}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </form>
      <Row md={"auto"} className="justify-content-center pt-12">
        <Button
          margin="10px"
          padding="20px"
          text="Add"
          onClick={handleSubmit}
          disabled={loadBtn}
        />
        <Button
          margin="10px"
          padding="20px"
          text="Back"
          onClick={handleBackClick}
        />
      </Row>
    </div>
  );
};

export default AddCustomer;
